const editPerformanceFormTypes = {
  EDIT: 'EDIT',
  NEW: 'NEW',
};

export default editPerformanceFormTypes;
